import React from 'react';

const StreamingIcon = ({link, fileName, name, iconClass}) => (
  <a href={link} target="_blank" rel="noopener noreferrer">
    <img className={iconClass} src={`./assets/${fileName}`} alt={name} />
  </a>
);

export default StreamingIcon;